import { MagistralDrugMedicinePrescription, MedicinePrescription } from '../types';

export const isMagistralDrugMedicinePrescription = (
   medicinePrescription: MedicinePrescription
): medicinePrescription is MagistralDrugMedicinePrescription => {
   return 'magistralDrug' in medicinePrescription;
};
